import React from 'react';
import { SVGIcon } from '@peoplegrove/pg-components';

function Rating({ rating }) {
  let iconProps = {};
  if (rating === 'Thumbs up') {
    iconProps = { icon: 'pg-thumbs-up-o', style: { color: 'green' } };
  } else if (rating === 'Thumbs down') {
    iconProps = { icon: 'pg-thumbs-down-o', style: { color: 'red' } };
  }

  return iconProps ? (
    <div>
      <SVGIcon {...iconProps} />
    </div>
  ) : null;
}

export default Rating;
